export default function checkIsJson(str: string): boolean {
  try {
    return JSON.parse(str) && !!str
  } catch (e) {
    return false
  }
}
